import { urlBuilder } from '@/connectors/endpoints'
import AxiosRequestBuilder from '@/utils/axios-request-builder'

const checkEmail = (email: string, endPoint: string) => {
  return new AxiosRequestBuilder({
    url: urlBuilder(endPoint, email),
    method: 'get'
  }).exec()
}

export default checkEmail
